@import '../../../globals/main.scss';

@import './pn-marketweb-siteheader-common.scss';

pn-marketweb-siteheader-login-linklist {
  display: flex;
  flex-direction: column;

  .pn-marketweb-siteheader-login-linklist-heading {
    font-weight: 500;
    font-size: 1.6rem;
    margin-bottom: 2.4rem;
  }
  
  strong {
    margin-bottom: 2.4rem;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  ul > li {
    margin-bottom: 2.4rem;
    a:not(.pn-button) {
      color: $blue700;
    }

    a {
      text-decoration: none;
      font-size: 1.6rem;
      line-height: 1.5;
      font-weight: 500;
    }

    pn-icon {
      padding-left: 0.8rem;
      svg > path {
        fill: $blue700 !important;
      }
    }

    &:hover {
      a {
        color: $blue900;
        text-decoration: underline;
      }

      pn-icon {
        svg > path {
          fill: $blue900 !important;
        }
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}